import { createAction } from 'redux-actions';
import * as orderItemFormTypes from './orderItemFormTypes';

export const onProcessTypeSelected = createAction(orderItemFormTypes.PROCESS_TYPE_SELECTED, processTypeId => ({
  processTypeId,
}));
export const onChangeCheckValues = createAction(orderItemFormTypes.ON_CHANGE_CHECK_VALUES, data => data);
